import type { ReactNode } from 'react'
import React from 'react'
import { Stack } from 'react-bootstrap'
import type { StackProps } from 'react-bootstrap/Stack'

export type HorizontalStackProps = Omit<StackProps, 'direction' | 'children'> & {
  children: ReactNode
}

export const HorizontalStack = ({ children, ...rest }: HorizontalStackProps) => {
  return (
    <Stack direction="horizontal" {...rest}>
      {children}
    </Stack>
  )
}
